export enum CompareEnum {
  PrevPolicy = 'Poprzednia polisa',
  ShowPrevPoliceToCompare = 'Pokaż poprzednią polisę',
}
